import { render, staticRenderFns } from "./BlocksAndAlertsItem.vue?vue&type=template&id=67ba1f95&scoped=true&"
import script from "./BlocksAndAlertsItem.vue?vue&type=script&lang=js&"
export * from "./BlocksAndAlertsItem.vue?vue&type=script&lang=js&"
import style0 from "./BlocksAndAlertsItem.vue?vue&type=style&index=0&id=67ba1f95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba1f95",
  null
  
)

export default component.exports